import { render, staticRenderFns } from "./autoTestLDS.vue?vue&type=template&id=3005a2cd&scoped=true"
import script from "./autoTestLDS.vue?vue&type=script&lang=js"
export * from "./autoTestLDS.vue?vue&type=script&lang=js"
import style0 from "./autoTestLDS.vue?vue&type=style&index=0&id=3005a2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005a2cd",
  null
  
)

export default component.exports